import styled from '@emotion/styled'
import {
    breakpoint,
    calcRem,
    visuallyhidden,
    zIndex,
} from '../../../../__styling'

export const pnArticleVideoClassName = 'pn-article-video'
export const pnArticleStickyVideoClassName = 'is-sticky'

export interface StyledPNArticleVideoProps {}

export const StyledPNArticleVideo = styled('figure')<StyledPNArticleVideoProps>(
    {
        flexGrow: 1,

        pointerEvents: 'auto',
    },
)

export const StyledStickyObservedCell = styled('div')()

export const StyledStickyCell = styled('div')({
    display: 'block',

    [`&.${pnArticleStickyVideoClassName}`]: {
        position: 'fixed',
        bottom: calcRem(16),
        right: calcRem(16),
        width: calcRem(375),
        height: 'auto',
        zIndex: zIndex.common.stickyVideo,

        // Remove margin from StyledArticleVideoContainer so it doesnt overlap the mrec
        [`& > div:first-child`]: {
            marginBottom: 0,
        },

        // If there is a figcaption we don't want it to be sticky.
        '& .figcaption': {
            ...visuallyhidden,
        },

        '.vjs-progress-bar': {
            height: '5px !important',
            top: '5px !important',
        },
    },
})
